  const message = {
    state: {
      sysMsg:{
        dialog:false,
        mid:0,
        title:'',
        content:'',
        remind:false
      },
      moodleMsg:{
        mid:0,
        title:'',
        content:''
      },
      classMsg:{
        dialog:false,
        processing:false,
        mid:0,
        title:'',
        content:''
      },
      paypalMsg:{
        dialog:false,
        processing:false,
        salaryAccount:''
      },
      noReadMsg:{
        total:0
      },
      selfScheduleRemindMsg: {
        isShow: false,
        tips: ''
      },
      didiMsg: {
        isShow: false,
        tips: ''
      },
      absentMsg:{
        dialog:false,
        classTime:"",
        id:"",
        count:0
      },
      //新增首页铃铛总消息
      homeMsg:{
        total:0
      },
      homeNoticeMsg:{
        total:0
      },
      homeWarnMsg:{
        total:0
      },
      homeRemindMsg:{
        total:0
      }
    },
    
  
    mutations: {
      SET_ABSENTMSG:(state,msg)=>{
        state.absentMsg = msg
      },
      SET_ABSENTMAG_DIALOG:(state,dialog)=>{
        state.absentMsg.dialog = dialog
      },
    SET_MOODLEMSG: (state, msg) => {
        state.moodleMsg = msg
    },
      SET_PAYPALMSG: (state, msg) => {
        state.paypalMsg = msg
      },
      SET_PAYPALMSG_DIALOG: (state, dialog) => {
        state.paypalMsg.dialog = dialog
        state.paypalMsg.processing=true
      },
      SET_SYSMSG: (state, msg) => {
        state.sysMsg = msg
      },
      SET_SYSMSG_DIALOG: (state, dialog) => {
        state.sysMsg.dialog = dialog
      },
      SET_CLASSMSG: (state, msg) => {
        state.classMsg = msg
      },
      SET_CLASSMSG_DIALOG: (state, {dialog,processing}) => {
        state.classMsg.dialog = dialog
        state.classMsg.processing=processing
      },
      SET_NOREAD_MSG: (state, {total}) => {
        state.noReadMsg.total=total
      },
      SET_SELFSCHEDULEREMIND_MSG: (state, msg) => {
        state.selfScheduleRemindMsg = msg
      },
      SET_DIDI_MSG: (state, msg) => {
        console.log(msg);
        state.didiMsg = msg
      },
      //新增首页铃铛总消息
      SET_HOME_MSG:(state,{total})=>{
        state.homeMsg.total=total
      },
        SET_HOME_NOTICE_MSG:(state,{total})=>{
        state.homeNoticeMsg.total=total
      },
        SET_HOME_WARN_MSG:(state,{total})=>{
        state.homeWarnMsg.total=total
      },
        SET_HOME_REMIND_MSG:(state,{total})=>{
        state.homeRemindMsg.total=total
      }
    },
    actions: {
      addAbsentMsg ({
        commit
      }, msg) {
        commit('SET_ABSENTMSG', {dialog:true,...msg})
      },
      closeAbsentMsg({
        commit
      }){
        commit('SET_ABSENTMAG_DIALOG',false)
      },
        addMoodleMsg ({
            commit
        }, msg) {
            commit('SET_MOODLEMSG', {dialog:true,...msg})
        },
      addSysMsg ({
        commit
      }, msg) {
        commit('SET_SYSMSG', {dialog:true,...msg})
      },
      closeSysMsg ({
        commit
      }) {
        commit('SET_SYSMSG_DIALOG', false)
      },
      addClassMsg ({
        commit,state
      }, msg) {
        commit('SET_CLASSMSG', {dialog:!state.classMsg.processing,processing:state.classMsg.processing,...msg})
      },
      closeClassMsg ({
        commit
      },processing) {
        commit('SET_CLASSMSG_DIALOG', {dialog:false,processing:processing||false})
      },
      openClassMsg ({
        commit
      }) {
        commit('SET_CLASSMSG_DIALOG', {dialog:true,processing:false})
      },
      addPaypalMsg ({
        commit,state
      }, msg) {
        commit('SET_PAYPALMSG', {dialog:!state.paypalMsg.processing,processing:state.paypalMsg.processing,...msg})
      },
      closePaypalMsg ({
        commit
      }) {
        commit('SET_PAYPALMSG_DIALOG', false)
      },
      addNoReadMsg ({
        commit
      }, total) {
        commit('SET_NOREAD_MSG', {total})
      },
      addSelfScheduleRemindMsg ({
        commit,state
      }, msg) {
        commit('SET_SELFSCHEDULEREMIND_MSG', {...msg})
      },
      addDidiMessage ({
        commit,state
      }, msg) {
        commit('SET_DIDI_MSG', {dialog:true,...msg})

      },
      //新增首页铃铛总消息
      addHomeMsg({commit},total){
        commit('SET_HOME_MSG',{total})
      },
      addHomeNoticeMsg({commit},total){
        commit('SET_HOME_NOTICE_MSG',{total})
      },
      addHomeWarnMsg({commit},total){
        commit('SET_HOME_WARN_MSG',{total})
      },
      addHomeRemindMsg({commit},total){
        commit('SET_HOME_REMIND_MSG',{total})
      },
    }
  }
  
  export default message
  